
const state = {
  logs: []
}

const mutations = {
  ADD_LOG: (state, log) => {
    state.logs.push(log)
  },
  CLEAR_LOG: (state) => {
    state.logs = []
  }
}

const actions = {
  addLog({ commit }, log) {
    commit('ADD_LOG', log)
  },
  clearLog({ commit }, log) {
    commit('CLEAR_LOG')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
